// <load-more-trigger>: progressive enhancement for the collection "Load more" link (see
// snippets/collection-load-more.liquid). Without JS the link simply goes to the next page.
if (!window.customElements.get('load-more-trigger')) {
  class LoadMoreTrigger extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      if (this.link) {
        this.link.addEventListener('click', this.onClick.bind(this));
      }
    }

    async onClick(event) {
      event.preventDefault();
      if (this.link.getAttribute('aria-busy') === 'true') return;

      const url = new URL(this.link.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      this.link.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(url.toString());
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newSection = parsed.querySelector('.shopify-section');

        const newGrid = newSection?.querySelector('.collection__results product-list');
        const currentGrid = this.closest('.collection')?.querySelector('.collection__results product-list');
        if (newGrid && currentGrid) {
          // reveal-on-scroll fades cards in via a one-time IntersectionObserver set up when
          // <product-list> first connects (see ProductList in theme.js) - appended cards would
          // never trigger it and would stay at opacity: 0 forever, so strip it before inserting.
          newGrid.querySelectorAll('[reveal-on-scroll]').forEach((el) => el.removeAttribute('reveal-on-scroll'));
          currentGrid.append(...newGrid.childNodes);
        }

        // The fetched page carries its own trigger, already pointed at the page after that (or
        // absent, if that was the last page) - swap it in rather than recomputing "next" here.
        const newTrigger = newSection?.querySelector('load-more-trigger');
        if (newTrigger) {
          this.replaceWith(newTrigger);
        } else {
          this.remove();
        }

        const statusHolder = document.getElementById('status-announcement');
        if (statusHolder && window.themeVariables?.strings?.productsLoaded) {
          statusHolder.textContent = '';
          setTimeout(() => { statusHolder.textContent = window.themeVariables.strings.productsLoaded; }, 100);
        }
      } catch (e) {
        this.link.removeAttribute('aria-busy');
      }
    }
  }

  window.customElements.define('load-more-trigger', LoadMoreTrigger);
}
